// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div:has(.CropStageCalendarContainer) {
    /* padding-bottom: 4rem; */
    background: #F5F5F7;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/CropStageCalander/CropStageCalendar.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB","sourcesContent":["div:has(.CropStageCalendarContainer) {\n    /* padding-bottom: 4rem; */\n    background: #F5F5F7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
